module.exports = __webpack_public_path__ + "static/media/logo_turtle_transparent.20ae14e1.png";